module.exports = __webpack_public_path__ + "img/edit.004d51c2.png";